const zh_tw = require("./apexLocales/zh-tw.json")
export default class CONST {
  static searchProcess = {
    chart: {
      defaultLocale: 'zh-tw',
      type: 'bar',
      height: 350,
      stacked: true,
      // stackType: '100%',
      toolbar: {
        show: true, // show/hide download button on apexcharts
      },
      zoom: {
        enabled: false, // show/hide zoom button on apexcharts
      },
      locales: [zh_tw],
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    subtitle: {
      text: '',
      align: '',
      offsetX: 70,
      margin: 30,
      style: {
        fontSize: '14px',
      },
    },
    xaxis: {
      categories: [],
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + "次"
        }
      }
    },
    fill: {
      opacity: 1
    
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'left',
      offsetX: 50
    }
  }

  static crossRegionSos = {
    chart: {
      defaultLocale: 'zh-tw',
      type: 'bar',
      stacked: true,
      height: 350,
      toolbar: {
        show: true, // show/hide download button on apexcharts
      },
      zoom: {
        enabled: false, // show/hide zoom button on apexcharts
      },
      locales: [zh_tw],
    },
    colors: ['#00ae9a'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    subtitle: {
      text: '',
      align: '',
     
      margin: 30,
      style: {
        fontSize: '14px',
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      title: {
        text: '警報次數'
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return  val + "次"
        }
      }
    }
  } 
}